module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"Netspeak Games","short_name":"netspeakgames","start_url":"/","background_color":"#161C4F","theme_color":"#161C4F","display":"minimal-ui","icon":"static/brand/icon.png","legacy":true,"theme_color_in_head":true,"cache_busting_mode":"query","crossOrigin":"anonymous","include_favicon":true,"cacheDigest":"691e594bef3195bbdd1b82c0d1ced474"},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    }]
